import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router/router'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.config.productionTip = false

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBGXi1_G103x2Ha3-pEqiPozTpbqCs5zNY",
    libraries: 'places', 
  },
})

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
